<template>
  <md-button class="md-primary" @click="$router.push(route)">
    <md-icon id="Ic_Arrow">arrow_back</md-icon>
    <slot />
  </md-button>
</template>

<script>
  const _bb = {
    name: 'back-button',
    props: {
      route: String
    }
  };
  
  export default _bb;
</script>

<style scoped>
  .md-button {
    margin: 10pt 0p;
  }

  @keyframes move {
    5% {
      transform: translateX(1pt);
    }
    100% {
      transform: translateX(-3pt);
    }
  }
  .md-button:hover #Ic_Arrow {
    animation: move 0.4s ease-in 0.1s 1 forwards;
  }
</style>



// WEBPACK FOOTER //
// src/components/BackButton.vue